<template>
    <b-modal size="lg" :id="id" 
            header-bg-variant="info"
            header-text-variant="white"
            body-bg-variant="light" 
            
            footer-bg-variant="light"
            :title="$t('account.template')"
            title-class="lead"
            >
                
            <p class="text-center text-muted smart-size mt-2 mb-4">{{$t('saved.templates')}}</p>
            <table class="table table-sm table-striped border-bottom">
                <tbody>
                    <b-jumbotron v-if="!templates.length">
	                    <p class="lead">{{$t('no.templates')}}</p>
                    </b-jumbotron>
                    <tr v-for="template in templates" :key="template.iban" >
                        <td class="accountTemplate text-left pl-2 pr-2 h6" @click="applyTemplate(template)">
                            {{template.receipient}}
                            <div class="text-muted"> {{template.iban}}
                            </div>    
                        </td>
                        <td class="text-right">
                            <b-button variant="outline-danger"  @click="deleteTemplate(template)" size="sm">
                                <IconDelete title="delete" />
                            </b-button>
                        </td>
                    </tr>	
                    </tbody>
            </table> 
            <div v-if="undeleteTemplate" class="text-right">
                <b-button variant="outline-danger"  @click="emptyTrash()" size="sm">
                    {{$t('empty.trash')}}
                </b-button>   
                &nbsp;
                <b-button variant="outline-info"  @click="undelete(template)" size="sm">
                    {{$t('undo.delete.template')}}
                </b-button>
            </div>        
        <template #modal-footer="{ hide }">
            <b-button variant="secondary" block @click="hide('forget')">{{$t('close')}}</b-button>
      </template>
                    
    </b-modal>
    </template>
    
    <script>
    import { mapGetters, mapState } from 'vuex'
    import IconDelete from 'vue-material-design-icons/TrashCanOutline'

    export default {
        props: ['id'],
        data () {
            return {   }
        },
        components:{
            IconDelete
        },
        computed:{
            ...mapGetters(['templates', 'undeleteTemplate'])
        },
        
        methods:{
            applyTemplate(template){
                this.$store.dispatch('applyTemplate', template)
                this.$bvModal.hide('accountTemplatesModal')
                
            },
            deleteTemplate(template){
                this.$store.dispatch('deleteTemplate', template)
            },
            undelete(){
                this.$store.dispatch('undelete')
            },
            emptyTrash(){
                this.$store.dispatch('emptyTrash')
            }
            
        }
    }
    
    </script>
    
    <style scoped>
   .accountTemplate{
     cursor: pointer;
   }
    </style>